import FormInput from './FormInput'

import NumberInput from '../NumberInput'
FormInput.registerType('number', NumberInput)

export default FormInput
